import { parseNovelCatalog, parseNovelPackDetail } from '@drama/contracts/novel'

/**
 * 互动小说书架：两个接口都公开，首页分区、书架与详情页未登录也要能看。
 * @param {ReturnType<import('../../transport.js').createTransport>} transport
 */
export function createNovelCatalogApi(transport) {
  return {
    /**
     * @param {string} [locale] 店面语言；不改变作品正文语言。
     * @returns {Promise<import('@drama/contracts/novel').NovelCatalogT>}
     */
    catalog(locale = 'en') {
      return transport.request('GET', '/api/novel/catalog', { public: true, query: { locale }, parse: parseNovelCatalog })
    },

    /**
     * 作品不存在或已下架时抛 ApiError（code = NOT_FOUND）。
     * @param {string} slug
     * @param {string} [locale] 店面语言；不改变作品正文语言。
     * @returns {Promise<import('@drama/contracts/novel').NovelPackDetailT>}
     */
    pack(slug, locale = 'en') {
      return transport.request('GET', `/api/novel/packs/${encodeURIComponent(slug)}`, { public: true, query: { locale }, parse: parseNovelPackDetail })
    },
  }
}
